<template>
  <form @submit.prevent>
    <div class="row px-5">
      <div class="col-md-6 pl-md-5" :class="attestations.length > 0 ? 'col-md-push-6' : 'col-md-push-3'">
        <credit-card-form :stripe-elements="stripeElements" @validity-change="onCardValidityChange" />

        <billing-address :states="states" :disabled="loadingEstimates" @change="onAddressChange" />

        <coupons-form :disabled="loadingEstimates" v-model="coupons" />

        <slot></slot>
      </div>

      <div v-show="attestations.length > 0" class="col-md-6 col-md-pull-6 pr-md-5">
        <attestations-form :attestations="attestations" :user="user" @validity-change="onAttestationsValidityChange" />
      </div>
    </div>

    <signature-form v-show="attestations.length > 0" :user="user" @validity-change="onSignatureValidityChange" />

    <div v-if="globalError" class="alert alert-danger my-5" role="alert">
      {{ globalError }}
    </div>

    <div class="text-center py-5">
      <button :disabled="!formValid || loading" type="button" class="btn btn-primary btn-lg" @click="onPayClick">
        <i v-if="loading" class="fas fa-fw fa-spinner fa-spin mr-2"></i>
        {{ loading ? 'Paying...' : 'Pay' }}
      </button>
    </div>
  </form>
</template>

<script>
import AttestationsForm from './AttestationsForm';
import CouponsForm from './CouponsForm.vue';
import CreditCardForm from './CreditCardForm';
import StateSelect from './StateSelect';
import SignatureForm from './SignatureForm';
import BillingAddress from './BillingAddress';

export default {
  name: 'payment-form',
  components: {BillingAddress, AttestationsForm, CreditCardForm, CouponsForm, StateSelect, SignatureForm},
  props: {
    attestations: {
      type: Array,
      required: true,
    },
    globalError: {
      type: String,
    },
    loading: {
      type: Boolean,
    },
    loadingEstimates: {
      type: Boolean,
    },
    states: {
      type: Array,
    },
    stripeElements: {
      type: Object,
    },
    user: {
      type: Object,
    },
  },
  data() {
    return {
      attestationsValid: false,
      cardValid: false,
      coupons: [],
      signatureValid: false,
      address: {},
      url: window.location.href,
    };
  },
  computed: {
    formData() {
      return {
        coupons: this.coupons,
        address: this.address,
      };
    },
    formValid() {
      return (
        this.cardValid &&
        this.addressValid &&
        (this.attestations.length === 0 || (this.attestationsValid && this.signatureValid))
      );
    },
    addressValid() {
      return !!this.address.state && !!this.address.city && !!this.address.state && !!this.address.zip;
    },
  },
  methods: {
    onAddTerritoriesClick(event) {
      event.preventDefault();
      this.$emit('add-territories');
    },
    onAttestationsValidityChange(valid) {
      this.attestationsValid = valid;
    },
    onCardValidityChange(valid) {
      this.cardValid = valid;
    },
    onSignatureValidityChange(valid) {
      this.signatureValid = valid;
    },
    onPayClick() {
      if (!this.formValid) {
        return;
      }

      this.$emit('pay', this.formData);
    },
    onAddressChange(address) {
      this.address = address;
    },
  },
  watch: {
    formData(value) {
      if (this.addressValid) {
        this.$emit('change', value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-security-disc {
  -webkit-text-security: disc;
}
</style>
